module.exports = __webpack_public_path__ + "static/media/sm_slices_2.888df86e.jpg";